<template>
  <div class="container">
    <!---Search-->
    <div class="grid grid-cols-[1fr_35px] gap-4">
      <div class="search mb-8">
        <svg class="search__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
        <input id="search" name="search" v-model="search" class="input" :class="{ 'show': showSearch }" type="text"
          placeholder="Buscar por correlativo, celular o nombre...">
      </div>
      <div>
        <button class="w-[35px] h-[35px] rounded-[10px] flex items-center justify-center bg-gray-200"
          @click="filter('hold')">
          <refresh-icon class="h-4"></refresh-icon>
        </button>
      </div>
    </div>

    <!---Filter-->
    <div class="flex justify-between gap-8 sticky bg-gray-100 py-4 mb-4 top-0">
      <div class="[&_span]:block [&_span]:tracking-tight text-center cursor-pointer"
        :class="{ 'border-primary border-solid border-b-[3px] pb-2': currentSelectedStatus === 'hold' }"
        @click="filter('hold')">
        <span>{{ holdCount }}</span>
        <span>PENDIENTES</span>
      </div>
      <div class="[&_span]:block [&_span]:tracking-tight text-center cursor-pointer"
        :class="{ 'border-primary border-solid border-b-[3px] pb-2': currentSelectedStatus === 'done' }"
        @click="filter('done')">
        <span>{{ doneCount }}</span>
        <span>EXITOSAS</span>
      </div>
      <div class="[&_span]:block [&_span]:tracking-tight text-center cursor-pointer"
        :class="{ 'border-primary border-solid border-b-[3px] pb-2': currentSelectedStatus === 'failed' }"
        @click="filter('failed')">
        <span>{{ failedCount }}</span>
        <span>FALLIDAS</span>
      </div>
    </div>

    <div class="grid grid-cols-3 gap-6 lg:grid-cols-1">
      <!---List-->
      <div v-for="(o, index) in filteredList" :key="index" @click="getDetail(o)"
        class="bg-gray-200 rounded-lg p-4 cursor-pointer">
        <span class="text-sm mb-4 font-semibold bg-primary inline-block text-white px-4 py-2 rounded-full">{{
          o.correlative }}</span>
        <span class="block text-sm mb-2 pb-2 border-b-[1px] border-solid border-gray-400"><strong
            class="font-semibold">Cliente:</strong> {{ o.client.name }}</span>
        <span class="block text-sm mb-2 pb-2 border-b-[1px] border-solid border-gray-400 truncate"><strong
            class="font-semibold">Ubicación:</strong> {{ o.address }}</span>
        <span class="block text-sm mb-2 pb-2 border-b-[1px] border-solid border-gray-400"><strong
            class="font-semibold">Recibe:</strong> {{ o.fullName }}</span>
        <span class="block text-sm mb-2 pb-2 border-b-[1px] border-solid border-gray-400"><strong
            class="font-semibold">Celular:</strong> {{ o.phone }}</span>
        <span class="block text-sm mb-2 pb-2 border-b-[1px] border-solid border-gray-400"><strong
            class="font-semibold">Cantidad de paquetes:</strong> {{ o.quantity }}</span>
        <span class="block text-sm mb-2 pb-2 border-b-[1px] border-solid border-gray-400"><strong
            class="font-semibold">Fecha de entrega:</strong> {{ o.deadline }}</span>
        <span v-if="o.totalAmount" class="block text-sm"><strong class="font-semibold">Total a cobrar:</strong> {{
          o.totalAmount }}</span>
      </div>
    </div>
    <!--End-->

    <!---Detail--->
    <div class="fixed flex flex-col top-0 bottom-0 left-0 bg-gray-100 z-[101]" style="height: 100dvh; width: 100vw;"
      :class="{ 'hidden': !showDetail }">
      <div class="container flex-grow overflow-y-auto overflow-x-hidden">
        <!---Correlative and back--->
        <div class="flex gap-4 items-center mb-12">
          <back-icon class="h-8 cursor-pointer" @click="backAction"></back-icon>
          <span class="text-sm font-semibold bg-primary inline-block text-white px-4 py-2 rounded-full">{{
            selectedDetail?.correlative }}</span>
        </div>

        <!---Detail--->
        <div v-if="!showSuccess & !showFailed">
          <div class="mb-4 border-b-[1px] border-solid border-gray-400 pb-4">
            <strong class="font-semibold text-sm">TIENDA</strong>
            <span class="block text-base">{{ selectedDetail?.client.name }}</span>
          </div>

          <div class="mb-4 border-b-[1px] border-solid border-gray-400 pb-4">
            <strong class="font-semibold text-sm">RECIBE</strong>
            <span class="block text-base">{{ selectedDetail?.fullName }}</span>
          </div>

          <div class="mb-4 border-b-[1px] border-solid border-gray-400 pb-4">
            <div class="mb-2">
              <strong class="font-semibold text-sm">UBICACIÓN</strong>
              <span class="block text-base">{{ selectedDetail?.address }}</span>
            </div>
            <div class="flex gap-2">
              <button class="bg-secondary text-white font-body text-sm py-2 px-4 rounded-full flex gap-2 items-center"
                @click="openGoogleMaps(selectedDetail?.address)">
                <navigate-icon class="h-4"></navigate-icon>
                <span>Navegar</span>
              </button>
              <button class="bg-secondary text-white font-body text-sm py-2 px-4 rounded-full flex gap-2 items-center"
                @click="openWhatsApp(selectedDetail?.phone, selectedDetail?.client.name)">
                <message-icon class="h-4"></message-icon>
                <span>Notificar</span>
              </button>
            </div>
          </div>

          <div class="border-b-[1px] border-solid border-gray-400 pb-4 mb-4">
            <div class="mb-2">
              <strong class="font-semibold text-sm">CELULAR</strong>
              <span class="block text-base">{{ selectedDetail?.phone }}</span>
            </div>
            <button class="bg-secondary text-white font-body text-sm py-2 px-4 rounded-full flex gap-2 items-center"
              @click="callPhoneNumber(selectedDetail?.phone)">
              <phone-icon class="h-4"></phone-icon>
              <span>Llamar</span>
            </button>
          </div>

          <div class="border-b-[1px] border-solid border-gray-400 pb-4 mb-4" v-if="selectedDetail?.notes || selectedDetail?.product">
            <strong class="font-semibold text-sm">NOTAS</strong>
            <span class="block text-base">{{ [selectedDetail?.notes, selectedDetail?.product].filter(Boolean).join(' - ') }}</span>
          </div>

          <div class="border-b-[1px] border-solid border-gray-400 pb-4" v-if="selectedDetail?.totalAmount">
            <strong class="font-semibold text-sm">TOTAL A COBRAR</strong>
            <span class="block text-base">{{ selectedDetail?.totalAmount }}</span>
          </div>
        </div>

        <!--Voucher-->
        <div v-if="showSuccess || showFailed" class="mt-8 mb-8">
          <div v-if="previews.length" class="grid grid-cols-3 gap-2 mb-4">
            <div v-for="(p, index) in previews" :key="index"
              class="relative aspect-square rounded-lg overflow-hidden bg-gray-200">
              <img class="w-full h-full object-cover" :src="p" alt="Voucher">
              <button
                class="absolute top-1 right-1 bg-red-600 text-white rounded-full w-6 h-6 text-xs flex items-center justify-center"
                @click="removeImage(index)">✕</button>
            </div>
          </div>
          <button :disabled="imageUploading || attachments.length >= 3" :class="{ 'is-loading': imageUploading }"
            class="btn btn--outline btn--w100 text-xs" @click="$refs.uploadVoucher.click()">
            <span v-if="!imageUploading">Adjuntar fotos ({{ attachments.length }}/3)</span>
          </button>
          <input @change="updateImage" class="file" ref="uploadVoucher" type="file" accept="image/*" multiple
            capture="environment">
          <span v-if="validationErrors.deliveryImage" class="error">{{ validationErrors.deliveryImage }}</span>
        </div>

        <!--Success-->
        <div v-if="showSuccess" class="space-y-4">
          <!--Total a cobrar-->
          <div class="form-group">
            <label for="totalAmount">Total a cobrar</label>
            <input v-model="success.totalAmount" class="input w-full" type="number" id="totalAmount" name="totalAmount"
              placeholder="0.00" :readonly="success.motive === 'Pago Mixto'" />
          </div>
          <!--Motive-->
          <div class="form-group">
            <label for="district">Motivo*</label>
            <select v-model="success.motive" class="select" name="motive" id="motive">
              <option v-for="(m, index) in succesMotives" :value="m" :key="index">{{ m }}</option>
            </select>
            <span v-if="validationErrors.motive" class="error">{{ validationErrors.motive }}</span>
          </div>

          <!--Mixed Payment-->
          <div v-if="success.motive === 'Pago Mixto'"
            class="space-y-4 border-[1px] border-solid border-gray-400 rounded-lg p-4">
            <strong class="font-semibold text-sm block">Detalle de pago mixto</strong>
            <!--Payment 1-->
            <div class="grid grid-cols-2 gap-2">
              <div class="form-group">
                <label>Método 1*</label>
                <select v-model="success.mixedPayment1Method" class="select">
                  <option v-for="(a, index) in mixedAccountDetailsList" :value="a" :key="index">{{ a }}</option>
                </select>
              </div>
              <div class="form-group">
                <label>Monto 1*</label>
                <input v-model.number="success.mixedPayment1Amount" class="input w-full" type="number"
                  placeholder="0.00" />
              </div>
            </div>
            <!--Payment 2-->
            <div class="grid grid-cols-2 gap-2">
              <div class="form-group">
                <label>Método 2*</label>
                <select v-model="success.mixedPayment2Method" class="select">
                  <option v-for="(a, index) in mixedAccountDetailsList" :value="a" :key="index">{{ a }}</option>
                </select>
              </div>
              <div class="form-group">
                <label>Monto 2*</label>
                <input v-model.number="success.mixedPayment2Amount" class="input w-full" type="number"
                  placeholder="0.00" />
              </div>
            </div>
            <span v-if="validationErrors.mixedPayment" class="error">{{ validationErrors.mixedPayment }}</span>
          </div>

          <!--Commets-->
          <div class="form-group">
            <label for="fullName">Comentarios*</label>
            <textarea v-model="success.comments" class="textarea w-full resize-none" rows="6" type="text" id="comments"
              name="comments" />
            <span v-if="validationErrors.comments" class="error">{{ validationErrors.comments }}</span>
          </div>
          <!--Account Details-->
          <div class="form-group">
            <label for="district">Detalle de cuenta*</label>
            <select v-model="success.accountDetails" class="select" name="accountDetails" id="accountDetails">
              <option v-for="(a, index) in accountDetailsList" :value="a" :key="index">{{ a }}</option>
            </select>
            <span v-if="validationErrors.accountDetails" class="error">{{ validationErrors.accountDetails }}</span>
          </div>

          <button :disabled="imageUploading" class="btn  bg-secondary w-full text-white text-xs" @click="done">{{ imageUploading ? 'Subiendo fotos...' : 'ENVIAR' }}</button>
        </div>

        <!--Failed-->
        <div v-if="showFailed" class="space-y-4">
          <!--Commets-->
          <div class="form-group">
            <label for="fullName">Comentarios*</label>
            <textarea v-model="failed.comments" class="textarea w-full resize-none" rows="6" type="text" id="comments"
              name="comments" />
            <span v-if="validationErrors.comments" class="error">{{ validationErrors.comments }}</span>
          </div>
          <!--Status-->
          <div class="form-group">
            <label for="district">Estado*</label>
            <select v-model="failed.status" class="select" name="status" id="status">
              <option v-for="(o, index) in failedStatus" :value="o.value" :key="index">{{ o.label }}</option>
            </select>
            <span v-if="validationErrors.status" class="error">{{ validationErrors.status }}</span>
          </div>

          <button :disabled="imageUploading" class="btn  bg-secondary w-full text-white text-xs" @click="done">{{ imageUploading ? 'Subiendo fotos...' : 'ENVIAR' }}</button>
        </div>
      </div>
      <!---Buttons--->
      <div v-if="!showFailed && !showSuccess" class="sticky bottom-0 bg-gray-100 py-4">
        <div class="grid grid-cols-2">
          <button class="btn btn--rect bg-red-600 text-white text-xs"
            @click="showSuccess = false, showFailed = true">FALLIDO</button>
          <button class="btn btn--rect bg-green-600 text-white text-xs"
            @click="showFailed = false, showSuccess = true">EXITOSO</button>
        </div>
      </div>
    </div>
    <!---End--->
  </div>
</template>

<script>
import { db, Timestamp, storage } from '@/firebase/firebaseConfig'
import axios from 'axios'
import * as yup from 'yup'
import imageCompression from 'browser-image-compression'

import moment from 'moment'
import RefreshIcon from '../components/atoms/icons/RefreshIcon.vue'
import BackIcon from '../components/atoms/icons/BackIcon.vue'
import NavigateIcon from '../components/atoms/icons/NavigateIcon.vue'
import MessageIcon from '../components/atoms/icons/MessageIcon.vue'
import PhoneIcon from '../components/atoms/icons/PhoneIcon.vue'
export default {
  name: 'Shipments',
  components: {
    PhoneIcon,
    MessageIcon,
    NavigateIcon,
    BackIcon,
    RefreshIcon
  },
  data() {
    return {
      list: [],
      successList: [],
      failedList: [],
      holdCount: 0,
      doneCount: 0,
      failedCount: 0,
      currentSelectedStatus: 'hold',
      showDetail: false,
      search: '',
      showSearch: true,
      imageUploading: false,
      attachments: [],
      previews: [],
      urls: [],
      selectedDetail: null,
      loadingSave: false,

      validationErrors: {},

      success: {
        motive: 'Efectivo',
        comments: '',
        accountDetails: '',
        mixedPayment1Method: '',
        mixedPayment1Amount: null,
        mixedPayment2Method: '',
        mixedPayment2Amount: null
      },
      succesMotives: [
        'Efectivo',
        'Solo dejar',
        'Pago Mixto',
        'A Tienda',
        'A Enwam',
        'Cambio mano a mano',
        'Recojo',
        'Devolución',
        'Prueba 2 Tallas'
      ],
      accountDetailsList: [
        'P.O.S',
        'Efectivo',
        'Solo dejar',
        'Yape',
        'Yape Enwam',
        'Yape Tienda',
        'Plin',
        'BCP',
        'BCP Enwam',
        'BCP Tienda',
        'Interbank Enwam',
        'Interbank Tienda',
        'BBVA',
        'Scotiabank',
        'Pago Mixto'
      ],
      showSuccess: false,
      showFailed: false,
      successSchema: yup.object().shape({
        motive: yup.string().required().label('Motivo'),
        comments: yup.string().required().label('Comentarios'),
        accountDetails: yup.string().required().label('Detalle de cuenta'),
        deliveryImage: yup.string().required().label('Foto')
      }),

      failed: {
        comments: '',
        status: ''
      },
      failedStatus: [
        {
          label: 'Anulado',
          value: 'canceled'
        },
        {
          label: 'Anulado con cobro',
          value: 'canceledWithCharge'
        },
        {
          label: 'Rechazado',
          value: 'rejected'
        },
        {
          label: 'Rechazado con cobro',
          value: 'rejectedWithCharge'
        },
        {
          label: 'Reprogramado con cobro',
          value: 'rescheduledWithCharge'
        },
        {
          label: 'Reprogramado sin cobro',
          value: 'rescheduledWithoutCharge'
        }
      ],
      failedSchema: yup.object().shape({
        comments: yup.string().required().label('Comentarios'),
        status: yup.string().required().label('Estado'),
        deliveryImage: yup.string().required().label('Foto')
      })
    }
  },
  async created() {
    this.$store.dispatch('setUser') // Set in store
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },
  beforeUnmount() {
    window.removeEventListener('popstate', this.handlePopState)
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    filteredList() {
      if (this.currentSelectedStatus === 'hold') return this.list.filter(o => { return (o.correlative + '' + o.address + '' + o.fullName + '' + o.phone + '' + o.client.name).toLowerCase().includes(this.search.toLowerCase()) })
      else if (this.currentSelectedStatus === 'done') return this.successList.filter(o => { return (o.correlative + '' + o.address + '' + o.fullName + '' + o.phone).toLowerCase().includes(this.search.toLowerCase()) })
      else return this.failedList.filter(o => { return (o.correlative + '' + o.address + '' + o.fullName + '' + o.phone).toLowerCase().includes(this.search.toLowerCase()) })
    },
    mixedAccountDetailsList() {
      return this.accountDetailsList.filter(a => a !== 'Pago Mixto' && a !== 'Solo dejar')
    }
  },
  watch: {
    'success.mixedPayment1Amount'() {
      this.updateMixedTotal()
    },
    'success.mixedPayment2Amount'() {
      this.updateMixedTotal()
    },
    'success.motive'(val) {
      if (val !== 'Pago Mixto') {
        this.success.mixedPayment1Method = ''
        this.success.mixedPayment1Amount = null
        this.success.mixedPayment2Method = ''
        this.success.mixedPayment2Amount = null
      }
    },
    async user(val) {
      try {
        if (val) {
          await this.filter('hold')
        }
      } catch (e) {
        this.$toast.error('Error al cargar datos', {
          duration: 6000
        })
      } finally {
        this.$store.dispatch('hideProgress')
      }
    }
  },
  methods: {
    async fetchCounts() {
      try {
        const { data } = await axios.get('https://southamerica-east1-enwam-8794a.cloudfunctions.net/detail-getShipmentCounts')
        this.holdCount = data.hold
        this.doneCount = data.done
        this.failedCount = data.failed
      } catch (e) {
        console.error('Error fetching counts', e)
      }
    },
    /**
     * Get detail
     */
    updateMixedTotal() {
      if (this.success.motive === 'Pago Mixto') {
        const amount1 = Number(this.success.mixedPayment1Amount) || 0
        const amount2 = Number(this.success.mixedPayment2Amount) || 0
        this.success.totalAmount = amount1 + amount2
      }
    },
    handleBeforeUnload(e) {
      e.preventDefault()
      e.returnValue = ''
    },
    handlePopState() {
      if (this.showSuccess || this.showFailed) {
        this.showSuccess = false
        this.showFailed = false
        history.pushState(null, '', location.href)
      } else if (this.showDetail) {
        this.showDetail = false
      }
    },
    async getDetail(o) {
      try {
        this.$store.dispatch('showProgress')
        this.attachments = []
        this.previews = []
        this.urls = []
        this.selectedDetail = o
        this.success.totalAmount = o.totalAmount ?? null
        this.showSuccess = false
        this.showFailed = false
        this.showDetail = true
        history.pushState(null, '', location.href)
        window.addEventListener('popstate', this.handlePopState)
      } catch (e) {
        this.$toast.error('Error al cargar detalle', {
          duration: 6000
        })
      } finally {
        this.$store.dispatch('hideProgress')
      }
    },
    /**
     * Confirm detail
     */
    async done() {
      try {
        if (!this.loadingSave) {
          this.$store.dispatch('showProgress')

          // Update assignment status
          if (this.showSuccess) {
            this.validationErrors = {}
            const successUrls = this.urls.filter((u) => !!u)
            this.success.deliveryImage = successUrls.length ? successUrls[0] : ''
            this.success.deliveryImages = successUrls
            await this.successSchema.validate({ ...this.success }, { abortEarly: false })
            await db.collection('detail').doc(this.selectedDetail.id).update({
              status: 'done',
              dealer: {
                ...this.success,
                dealerName: this.user?.name || '',
                dealerId: this.user?.id || '',
                dealerUid: this.user?.uid || ''
              }
            })
            this.success = {
              motive: 'Efectivo',
              comments: '',
              accountDetails: '',
              mixedPayment1Method: '',
              mixedPayment1Amount: null,
              mixedPayment2Method: '',
              mixedPayment2Amount: null
            }

            const findIndex = this.list.findIndex((l) => l.id === this.selectedDetail.id)
            this.successList.push({ ...this.list[findIndex] })
            this.list.splice(findIndex, 1)
            this.holdCount--
            this.doneCount++
          } else {
            this.validationErrors = {}
            const failedUrls = this.urls.filter((u) => !!u)
            this.failed.deliveryImage = failedUrls.length ? failedUrls[0] : ''
            this.failed.deliveryImages = failedUrls
            await this.failedSchema.validate({ ...this.failed }, { abortEarly: false })
            await db.collection('detail').doc(this.selectedDetail.id).update({
              status: this.failed.status,
              dealer: {
                ...this.failed,
                dealerName: this.user?.name || '',
                dealerId: this.user?.id || '',
                dealerUid: this.user?.uid || ''
              }
            })
            this.failed = {
              comments: '',
              status: ''
            }

            const findIndex = this.list.findIndex((l) => l.id === this.selectedDetail.id)
            this.failedList.push({ ...this.list[findIndex] })
            this.list.splice(findIndex, 1)
            this.holdCount--
            this.failedCount++
          }

          // End

          this.$toast.success('Datos guardados', {
            duration: 3000
          })

          this.showDetail = false
          this.showFailed = false
          this.showSuccess = false
          window.removeEventListener('popstate', this.handlePopState)
        }
      } catch (err) {
        console.log(err)
        if (err.inner) {
          err.inner.forEach(error => {
            if (error.path) {
              this.validationErrors[error.path] = error.message
            }
          })
        } else {
          this.$toast.error('Error al enviar', {
            duration: 6000
          })
        }
      } finally {
        this.$store.dispatch('hideProgress')
      }
    },
    /**
     * Upload images: compress, preview and upload in parallel
     */
    async updateImage(input) {
      if (!input.target.files || !input.target.files.length) return

      const files = Array.from(input.target.files)
      const remaining = 3 - this.attachments.length
      const toProcess = files.slice(0, remaining)

      if (files.length > remaining) {
        this.$toast.error(`Solo puedes agregar ${remaining} foto(s) más`)
      }

      input.target.value = ''
      this.imageUploading = true

      // Preview inmediato con object URL (no consume memoria como Base64)
      const startIndex = this.previews.length
      toProcess.forEach((file) => {
        this.previews.push(URL.createObjectURL(file))
        this.attachments.push(file)
        this.urls.push(null) // placeholder para mantener orden
      })

      try {
        // Comprimir y subir en paralelo
        const uploads = toProcess.map(async (file, i) => {
          const compressed = await this.compressImage(file)
          const url = await this.submitFile(compressed)
          this.urls.splice(startIndex + i, 1, url)
        })
        await Promise.all(uploads)
      } catch (e) {
        this.$toast.error('Error al cargar imagen')
      } finally {
        this.imageUploading = false
      }
    },
    /**
     * Compress and resize image before upload.
     * Falls back to original file if compression fails.
     */
    async compressImage(file) {
      try {
        const options = {
          maxSizeMB: 0.3,
          maxWidthOrHeight: 1280,
          useWebWorker: true,
          fileType: 'image/jpeg',
          initialQuality: 0.8
        }
        return await imageCompression(file, options)
      } catch (e) {
        console.warn('Image compression failed, uploading original', e)
        return file
      }
    },
    removeImage(index) {
      // Liberar memoria del preview
      const preview = this.previews[index]
      if (preview && preview.startsWith('blob:')) {
        URL.revokeObjectURL(preview)
      }
      this.attachments.splice(index, 1)
      this.previews.splice(index, 1)
      this.urls.splice(index, 1)
    },
    /**
     * Save doc in firebase storage
     * @param doc
     * @returns {Promise<unknown>}
     */
    submitFile(doc) {
      return new Promise((resolve, reject) => {
        const docName = Math.random().toString(36).substr(1, 20)
        const fileExtension = '.' + (doc.name ? doc.name.split('.').pop() : 'jpg')
        const docNameFinal = docName + fileExtension
        const storageRef = storage.ref(`shipments/${docNameFinal}`)
        storageRef.put(doc)
          .then((snapshot) => {
            snapshot.ref.getDownloadURL()
              .then((url) => resolve(url))
              .catch((error) => reject(error))
          })
          .catch((error) => reject(error))
      })
    },
    /**
     * Filter by status
     */
    async filter(status) {
      try {
        this.$store.dispatch('showProgress')
        this.currentSelectedStatus = status
        this.fetchCounts()
        // Set start date
        const startDate = new Date()
        const endDate = new Date()
        startDate.setHours(0)
        startDate.setMinutes(0)
        startDate.setSeconds(0)
        // Set end date
        endDate.setHours(23)
        endDate.setMinutes(59)
        endDate.setSeconds(0)

        let startTimes = null
        let endTimes = null
        // End

        startTimes = Timestamp.fromDate(startDate)
        endTimes = Timestamp.fromDate(endDate)

        let querySnapshot = null

        if (status !== 'hold' && status !== 'done') {
          // Get assigments of firestore
          querySnapshot = await db.collection('detail')
            .where('deadline', '>=', startTimes)
            .where('deadline', '<=', endTimes)
            .where('status', 'in', ['canceled', 'canceledWithCharge', 'rejected', 'rejectedWithCharge', 'rescheduledWithoutCharge', 'rescheduledWithCharge'])
            .orderBy('deadline', 'asc')
            .get()
          // End
        } else if (status === 'done') {
          // Get assigments of firestore
          querySnapshot = await db.collection('detail')
            .where('deadline', '>=', startTimes)
            .where('deadline', '<=', endTimes)
            .where('status', '==', 'done')
            .orderBy('deadline', 'asc')
            .get()
          // End
        } else if (status === 'hold') {
          // Get assigments of firestore
          querySnapshot = await db.collection('detail')
            .where('deadline', '>=', startTimes)
            .where('deadline', '<=', endTimes)
            .where('status', '==', 'hold')
            .orderBy('deadline', 'asc')
            .get()
          // End
        }

        this.list = []
        this.successList = []
        this.failedList = []

        querySnapshot.forEach((doc) => {
          const obj = {
            ...doc.data(),
            deadline: doc.data().deadline.toDate(),
            createdAt: doc.data().createdAt.toDate()
          }

          obj.id = doc.id
          obj.totalAmount = obj.totalToBeCollected ?? null

          obj.deadline = moment(obj.deadline).format('DD-MM-YYYY')
          obj.createdAt = moment(obj.createdAt).format('YYYY-MM-DD HH:mm')

          if (status !== 'hold' && status !== 'done') {
            this.failedList.push({
              ...obj
            })
          } else if (status === 'done') {
            this.successList.push({
              ...obj
            })
          } else if (status === 'hold') {
            this.list.push({
              ...obj
            })
          }
        })
      } catch (e) {
        console.log(e)
        this.$toast.error('Error al filtrar ')
      } finally {
        this.$store.dispatch('hideProgress')
      }
    },
    /**
     * Open google maps
     */
    openGoogleMaps(address) {
      const encodedAddress = encodeURIComponent(address)
      const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`
      window.open(googleMapsUrl, '_blank')
    },
    /**
     * Back
     */
    backAction() {
      if (this.showSuccess || this.showFailed) {
        this.showSuccess = false
        this.showFailed = false
      } else {
        this.showDetail = false
        window.removeEventListener('popstate', this.handlePopState)
      }
    },
    /**
     * Call Phone number
     */
    callPhoneNumber(phoneNumber) {
      if (!phoneNumber) return

      const cleanNumber = String(phoneNumber).replace(/[^\d+]/g, '')
      window.location.href = `tel:${cleanNumber}`
    },
    /**
     * Open WhatsApp
     */
    openWhatsApp(phoneNumber, storeName) {
      if (!phoneNumber || !storeName) return

      const cleanNumber = String(phoneNumber).replace(/\D/g, '')
      const now = new Date()
      const currentTime = now.toLocaleTimeString('es-PE', { hour: '2-digit', minute: '2-digit', hour12: true })
      const message = `Buen día, soy motorizado de *${storeName}*, para la entrega de su pedido.\n\nHorario de entrega: 12:00 pm – 6:30 pm\nLe avisaré 10–45 min antes de llegar.\n*Me comparte su ubicación en ${currentTime} por favor.*\n\nEn caso no se encuentre, puede indicarme quién recibirá.\nSi paga en efectivo, es necesario el monto exacto.\n(también aceptamos Yape/transferencia).\n*si ya pago omitir este mensaje.*\n\nEstaré a la espera de su ubicación por favor, gracias.\n\nEnwam Courier \n*Crezcamos juntos*\n*Tarifa plana s/.7.90 para Lima y Callao.*\n*Contacto wtsp: 943-444-307.*`
      const params = new URLSearchParams({ text: message })
      const url = `https://wa.me/${cleanNumber}?${params}`

      window.open(url, '_blank')
    }
  }
}
</script>
